export const englishFirstNames = [
    "Billy", "Wyatt", "Jesse", "Buffalo", "Doc", "Butch", "Sundance", "Calamity", "Annie", "Wild",
    "Kit", "Davy", "Virgil", "Morgan", "Cole", "Clay", "Tex", "Slim", "Red", "Lone",
    "Austin", "Dallas", "Houston", "Reno", "Denver", "Montana", "Dakota", "Arizona", "Nevada", "Cheyenne",
    "Clint", "John", "Wayne", "Gary", "Randolph", "Sam", "Lee", "Van", "Burt", "Kirk"
];

export const englishLastNames = [
    "Kid", "Earp", "James", "Bill", "Holliday", "Cassidy", "Jane", "Oakley", "Hickok", "Carson",
    "Crockett", "Younger", "Allison", "Hardin", "Bonney", "Masterson", "Garrett", "Starr", "Dalton", "Bass",
    "Wayne", "Cooper", "Scott", "Eastwood", "Ford", "Bronson", "Coburn", "Marvin", "Lancaster", "Douglas"
];

export const frenchFirstNames = [
    "Jacques", "Pierre", "Louis", "François", "Jean", "Michel", "André", "Henri", "Marcel", "Philippe",
    "Gaston", "Lucien", "Maurice", "René", "Claude", "Émile", "Léon", "Jules", "Raoul", "Georges",
    "Antoine", "Baptiste", "Étienne", "Julien", "Laurent", "Olivier", "Thierry", "Xavier", "Yves", "Zacharie"
];

export const frenchLastNames = [
    "Dubois", "Leroy", "Moreau", "Petit", "Blanc", "Roux", "Garnier", "Moulin", "Chevalier", "Mercier",
    "Dupont", "Durand", "Lefebvre", "Martin", "Bernard", "Thomas", "Robert", "Richard", "Simon", "Laurent",
    "Charbonneau", "Pelletier", "Tremblay", "Gauthier", "Roy", "Bouchard", "Côté", "Morin", "Lavoie", "Fortin"
];

export const turkishFirstNames = [
    "Rüzgar", "Kartal", "Şahin", "Poyraz", "Kuzey", "Doğu", "Batı", "Atmacalı", "Çöl", "Vahşi",
    "Demir", "Kaya", "Polat", "Aslan", "Kaplan", "Kurt", "Bozkurt", "Yaman", "Cesur", "Kara",
    "Ali", "Osman", "Mehmet", "Hasan", "Hüseyin", "Ömer", "Bekir", "Kemal", "Mustafa", "Murat"
];

export const turkishLastNames = [
    "Efe", "Zeybek", "Yörük", "Dadaş", "Seymen", "Akıncı", "Sipahi", "Yeniçeri", "Kozak", "Haydut",
    "Kovboy", "Silahşör", "Nişancı", "Avcı", "İzci", "Rehber", "Serdengeçti", "Delibaş", "Pehlivan", "Yiğit",
    "Çelik", "Korkmaz", "Yılmaz", "Öztürk", "Yıldırım", "Şimşek", "Tayfun", "Kasırga", "Bora", "Fırtına"
];

export const spanishFirstNames = [
    "Diego", "Pancho", "Cisco", "Joaquín", "Emiliano", "Zapata", "Santiago", "Miguel", "Alejandro", "Carlos",
    "Fernando", "Rafael", "Esteban", "Benito", "Ramón", "Ignacio", "Gonzalo", "Rodrigo", "Salvador", "Tomás",
    "Lobo", "Coyote", "Halcón", "Toro", "Águila", "Sombra", "Pistola", "Bandido", "Jinete", "Rayo"
];

export const spanishLastNames = [
    "Villa", "Zapata", "Diablo", "Fuego", "Tormenta", "Sombrero", "Espuela", "Revólver", "Cañón", "Sierra",
    "Desierto", "Polvo", "Seco", "Bravo", "Valiente", "Feroz", "Rudo", "Salvaje", "Peligro", "Mortal",
    "Mendoza", "Hernández", "Gutiérrez", "Salazar", "Vega", "Castillo", "Guerrero", "Montoya", "Cisneros", "Delgado"
];

export const germanFirstNames = [
    "Klaus", "Fritz", "Hans", "Karl", "Wilhelm", "Otto", "Heinrich", "Günter", "Wolfgang", "Dieter",
    "Siegfried", "Konrad", "Reinhard", "Bernhard", "Ludwig", "Erich", "Helmut", "Gerhard", "Manfred", "Werner",
    "Stahl", "Eisen", "Blitz", "Donner", "Sturm", "Wolf", "Adler", "Falke", "Bär", "Jäger"
];

export const germanLastNames = [
    "Schwarzkopf", "Eisenfaust", "Blitz", "Donner", "Sturm", "Wildbach", "Steinberg", "Falkenberg", "Wolfsburg", "Adler",
    "Jäger", "Reiter", "Schütze", "Krieger", "Ritter", "Stahl", "Hammer", "Schwert", "Klinge", "Panzer",
    "Braun", "Schmidt", "Müller", "Weber", "Fischer", "Becker", "Wagner", "Hoffmann", "Richter", "Koch"
];

export const portugueseFirstNames = [
    "João", "Pedro", "Carlos", "Antônio", "Francisco", "Manoel", "Sebastião", "Joaquim", "Raimundo", "José",
    "Cangaço", "Lampião", "Corisco", "Virgulino", "Dadá", "Jesuíno", "Volta", "Sinhô", "Zé", "Tibúrcio",
    "Gavião", "Trovão", "Raio", "Bravo", "Valente", "Couro", "Sertão", "Caatinga", "Vaqueiro", "Jagunço"
];

export const portugueseLastNames = [
    "Ferreira", "Santos", "Oliveira", "Souza", "Silva", "Pereira", "Costa", "Rodrigues", "Almeida", "Nascimento",
    "Brilhante", "Cangaceiro", "Sertanejo", "Vaqueiro", "Jagunço", "Matador", "Pistoleiro", "Capanga", "Coronel", "Bandido",
    "Trovão", "Tempestade", "Relâmpago", "Fogo", "Poeira", "Deserto", "Seca", "Brasa", "Pedra", "Ferro"
];

export const arabicFirstNames = [
    "صقر", "فارس", "سيف", "ذئب", "أسد", "نمر", "عقاب", "رعد", "برق", "ظل",
    "خالد", "عمر", "طارق", "صلاح", "حمزة", "عنتر", "زيد", "سعد", "جابر", "راشد",
    "بدوي", "صحراوي", "محارب", "فدائي", "شجاع", "مغامر", "رحال", "قناص", "حارس", "فتاك"
];

export const arabicLastNames = [
    "الصقر", "السيف", "الرعد", "البرق", "الذئب", "الأسد", "النمر", "العقاب", "الفارس", "الصياد",
    "الرماح", "الحداد", "النجار", "القناص", "المحارب", "الفدائي", "الشجاع", "البدوي", "الصحراوي", "الرحال",
    "العتيبي", "الشمري", "الحربي", "المطيري", "الدوسري", "القحطاني", "الغامدي", "الزهراني", "العنزي", "البلوي"
];

export const hindiFirstNames = [
    "विक्रम", "वीर", "रण", "बहादुर", "शूर", "योद्धा", "अमर", "धीर", "प्रताप", "राज",
    "शेर", "बाघ", "चीता", "गरुड़", "बाज", "भीम", "अर्जुन", "कर्ण", "द्रोण", "एकलव्य",
    "सूर्य", "अग्नि", "तूफ़ान", "बिजली", "गर्जन", "लोहा", "फ़ौलाद", "पत्थर", "चट्टान", "हीरा"
];

export const hindiLastNames = [
    "सिंह", "राठौर", "चौहान", "राजपूत", "ठाकुर", "शेखावत", "रावत", "परमार", "सोलंकी", "तोमर",
    "वीर", "बहादुर", "प्रताप", "शूर", "योद्धा", "निशानची", "तलवार", "बाण", "शस्त्र", "कवच",
    "तूफ़ान", "बिजली", "गर्जन", "आँधी", "रेगिस्तान", "मरुस्थल", "धूल", "अग्नि", "ज्वाला", "प्रलय"
];

export const japaneseFirstNames = [
    "竜馬", "一刀", "武蔵", "半蔵", "信長", "謙信", "幸村", "十兵衛", "五右衛門", "弁慶",
    "風", "雷", "嵐", "隼", "鷹", "狼", "虎", "龍", "鬼", "影",
    "剣", "刃", "鉄", "岩", "炎", "閃", "烈", "豪", "凄", "猛"
];

export const japaneseLastNames = [
    "坂本", "宮本", "服部", "柳生", "織田", "上杉", "真田", "伊達", "徳川", "武田",
    "荒野", "砂漠", "流浪", "無頼", "疾風", "迅雷", "烈火", "氷刃", "暗影", "鉄砲",
    "黒田", "赤井", "白石", "青山", "金城", "銀河", "鋼", "雷鳴", "旋風", "火炎"
];

export const koreanFirstNames = [
    "용마", "무현", "태풍", "천둥", "번개", "바람", "폭풍", "매", "독수리", "늑대",
    "호랑이", "사자", "철", "강", "바위", "불꽃", "칼날", "화살", "방패", "창",
    "건", "준", "혁", "민", "성", "진", "현", "우", "재", "석"
];

export const koreanLastNames = [
    "김", "이", "박", "최", "정", "강", "조", "윤", "장", "임",
    "한", "서", "권", "황", "안", "송", "류", "홍", "전", "고",
    "무법자", "총잡이", "사냥꾼", "방랑자", "결투사", "보안관", "기수", "척후", "저격수", "추적자"
];

export const indonesianFirstNames = [
    "Elang", "Harimau", "Singa", "Rajawali", "Serigala", "Banteng", "Garuda", "Badak", "Kijang", "Burung",
    "Guntur", "Petir", "Topan", "Angin", "Badai", "Baja", "Batu", "Api", "Kilat", "Gempa",
    "Adi", "Budi", "Cahyo", "Dwi", "Eko", "Fajar", "Galang", "Hadi", "Indra", "Joko"
];

export const indonesianLastNames = [
    "Pemberani", "Pendekar", "Pemburu", "Pengembara", "Penunggang", "Penembak", "Penjaga", "Pelacak", "Petualang", "Pahlawan",
    "Guntur", "Petir", "Topan", "Badai", "Halilintar", "Baja", "Besi", "Batu", "Api", "Debu",
    "Surya", "Chandra", "Putra", "Satria", "Wijaya", "Kusuma", "Pratama", "Nugraha", "Hidayat", "Permana"
];

export const vietnameseFirstNames = [
    "Hùng", "Dũng", "Mạnh", "Cường", "Kiệt", "Chiến", "Thắng", "Phong", "Bão", "Sấm",
    "Hổ", "Sói", "Đại Bàng", "Diều Hâu", "Rồng", "Sắt", "Thép", "Đá", "Lửa", "Sét",
    "Minh", "Tuấn", "Quang", "Đức", "Trung", "Thành", "Long", "Hải", "Nam", "Tùng"
];

export const vietnameseLastNames = [
    "Nguyễn", "Trần", "Lê", "Phạm", "Hoàng", "Huỳnh", "Phan", "Vũ", "Võ", "Đặng",
    "Bùi", "Đỗ", "Hồ", "Ngô", "Dương", "Lý", "Đinh", "Trương", "Lương", "Mai",
    "Sát Thủ", "Thiện Xạ", "Kỵ Sĩ", "Thợ Săn", "Lãng Tử", "Hiệp Sĩ", "Bảo Vệ", "Chiến Binh", "Dũng Sĩ", "Anh Hùng"
];

export const russianFirstNames = [
    "Волк", "Медведь", "Орёл", "Сокол", "Тигр", "Ястреб", "Беркут", "Барс", "Рысь", "Вепрь",
    "Гром", "Молния", "Буря", "Вихрь", "Ураган", "Сталь", "Булат", "Кремень", "Клинок", "Огонь",
    "Иван", "Дмитрий", "Алексей", "Николай", "Сергей", "Андрей", "Михаил", "Василий", "Фёдор", "Григорий"
];

export const russianLastNames = [
    "Волков", "Медведев", "Орлов", "Соколов", "Громов", "Молнин", "Бурев", "Стальной", "Огнев", "Клинков",
    "Казак", "Стрелок", "Охотник", "Следопыт", "Атаман", "Есаул", "Разбойник", "Ковбой", "Наездник", "Странник",
    "Черный", "Белый", "Красный", "Железный", "Каменный", "Быстрый", "Дикий", "Лихой", "Грозный", "Удалой"
];

export const italianFirstNames = [
    "Marco", "Angelo", "Salvatore", "Giovanni", "Lorenzo", "Vincenzo", "Antonio", "Domenico", "Raffaele", "Giuseppe",
    "Lupo", "Falco", "Aquila", "Leone", "Toro", "Fulmine", "Tuono", "Tempesta", "Fuoco", "Ferro",
    "Bandito", "Pistolero", "Cavaliere", "Cacciatore", "Vagabondo", "Sceriffo", "Sicario", "Guarda", "Ribelle", "Desperado"
];

export const italianLastNames = [
    "Rossi", "Russo", "Ferrari", "Esposito", "Bianchi", "Romano", "Colombo", "Ricci", "Marino", "Greco",
    "Selvaggio", "Fuoco", "Ferro", "Tempesta", "Tuono", "Fulmine", "Pietra", "Acciaio", "Fiamma", "Polvere",
    "Lupo", "Leone", "Falco", "Aquila", "Toro", "Serpente", "Drago", "Orso", "Tigre", "Corvo"
];

export const polishFirstNames = [
    "Wilk", "Orzeł", "Sokół", "Jastrząb", "Niedźwiedź", "Ryś", "Tur", "Żubr", "Byk", "Kania",
    "Grom", "Piorun", "Burza", "Wicher", "Huragan", "Stal", "Krzem", "Głaz", "Ogień", "Błysk",
    "Jan", "Stanisław", "Kazimierz", "Zbigniew", "Tadeusz", "Wojciech", "Zygmunt", "Mieczysław", "Władysław", "Bronisław"
];

export const polishLastNames = [
    "Wilk", "Orzeł", "Sokół", "Niedźwiedź", "Grom", "Piorun", "Burza", "Stal", "Ogień", "Żelazo",
    "Strzelec", "Łowca", "Tropiciel", "Jeździec", "Wędrowiec", "Kowboj", "Rewolwerowiec", "Strażnik", "Buntownik", "Zbój",
    "Kowalski", "Wiśniewski", "Wójcik", "Kamiński", "Lewandowski", "Zieliński", "Szymański", "Woźniak", "Dąbrowski", "Kozłowski"
];

export const dutchFirstNames = [
    "Wolf", "Arend", "Valk", "Havik", "Beer", "Lynx", "Stier", "Adelaar", "Ram", "Kraai",
    "Donder", "Bliksem", "Storm", "Wind", "Orkaan", "Staal", "Vuursteen", "Rots", "Vlam", "Flits",
    "Jan", "Pieter", "Willem", "Hendrik", "Cornelis", "Dirk", "Gerrit", "Jacobus", "Frederik", "Adriaan"
];

export const dutchLastNames = [
    "de Wolf", "van den Berg", "de Vries", "van Dijk", "de Boer", "Jansen", "Bakker", "Visser", "Smit", "Meijer",
    "Schutter", "Jager", "Spoorzoeker", "Ruiter", "Zwerver", "Cowboy", "Wachter", "Scherpschutter", "Rebel", "Bandiet",
    "Donder", "Bliksem", "Storm", "Staal", "IJzer", "Vuur", "Steen", "Vlam", "Stof", "Woestijn"
];
